import { hot } from "react-hot-loader/root"
import React from "react"
import "./assets/less/global.less"
import { ThemeProvider } from "@material-ui/core/styles"
import { Provider } from "react-redux"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import Login from "@/pages/Login"
import Admin from "@/pages/Admin"
import RequestPasswordReset from "@/pages/RequestPasswordReset"
import PasswordReset from "@/pages/PasswordReset"
import Register from "@/pages/Register"
import Invitation from "@/pages/Invitation"
import Assessment from "@/pages/Assessment"
import NewUserVerify from "@/pages/NewUserVerify"
import PublicLayout from "@/components/template/publicTemplate/PublicLayout"
import MyTheme from "./MyTheme"
import store from "./redux/store"
import PublicRouteCheckParticipantPermission from "./helpers/PublicRouteCheckParticipantPermission"

function App() {
    return (
        <Provider store={store}>
            <ThemeProvider theme={MyTheme}>
                <BrowserRouter>
                    <Routes>
                        <Route
                            path="login"
                            element={
                                <PublicLayout>
                                    <Login />
                                </PublicLayout>
                            }
                        />
                        <Route
                            path="request-password-reset"
                            element={
                                <PublicLayout>
                                    <RequestPasswordReset />
                                </PublicLayout>
                            }
                        />
                        <Route
                            path="password-reset"
                            element={
                                <PublicLayout>
                                    <PasswordReset />
                                </PublicLayout>
                            }
                        />
                        <Route
                            path="register"
                            element={
                                <PublicLayout>
                                    <Register />
                                </PublicLayout>
                            }
                        />
                        <Route
                            path="new-user-verify"
                            element={
                                <PublicLayout>
                                    <NewUserVerify />
                                </PublicLayout>
                            }
                        />
                        <Route
                            path="invitation/participant/:participantUUID"
                            element={
                                <PublicLayout>
                                    <PublicRouteCheckParticipantPermission>
                                        <Invitation />
                                    </PublicRouteCheckParticipantPermission>
                                </PublicLayout>
                            }
                        />
                        <Route
                            path="assessment/participant/:participantUUID"
                            element={
                                <PublicLayout>
                                    <PublicRouteCheckParticipantPermission>
                                        <Assessment />
                                    </PublicRouteCheckParticipantPermission>
                                </PublicLayout>
                            }
                        />
                        <Route path="*" element={<Admin />} />
                    </Routes>
                </BrowserRouter>
            </ThemeProvider>
        </Provider>
    )
}

// export default App

export default hot(App)
